import {
  Divider,
  Switch,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Grid } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatDate, formatTime } from '../../../../utils/date-helpers';
import { TextInput } from '../../BasicDetails/TextInput';
import SetupGridItem from '../../SetupGridItem';
import messages from '../messages';
import type { Props } from './types';

function LegacyScreeningsSetup({
  editMode,
  isTransUnionActive,
  isTransUnionToggleDisabled,
  transunionPropertyId,
  transunionOffLeaseAppOff,
  transUnionLatestChangeHistoryLog,
  transUnionIsLoading,
  handleSwitchChange,
  onChange,
  intl,
}: Props) {
  return (
    <>
      <Grid item xs={12}>
        <Divider sx={{ marginY: 2 }} />
        <Typography variant={'bodyLarge'}>
          <FormattedMessage {...messages.screenings} />
        </Typography>
      </Grid>
      <SetupGridItem label={<FormattedMessage {...messages.transunion} />}>
        {editMode ? (
          <Switch
            name="isTransUnionActive"
            id="trans-union-switch"
            checked={isTransUnionActive}
            disabled={!editMode}
            onChange={handleSwitchChange}
          />
        ) : isTransUnionActive ? (
          <FormattedMessage {...messages.on} />
        ) : (
          <FormattedMessage {...messages.off} />
        )}
      </SetupGridItem>
      {transunionOffLeaseAppOff && (
        <>
          {transUnionLatestChangeHistoryLog &&
            !transUnionIsLoading &&
            transUnionLatestChangeHistoryLog?.user && (
              <SetupGridItem>
                <Typography>
                  {intl.formatMessage(messages.transUnionLogHistoryMsg, {
                    transUnionToggleState:
                      transUnionLatestChangeHistoryLog.changeToValue === 'true'
                        ? 'On'
                        : 'Off',
                    // eslint-disable-next-line
                    userName: `${transUnionLatestChangeHistoryLog?.user?.firstName} ${transUnionLatestChangeHistoryLog?.user?.lastName}`,
                    formatDate: formatDate(
                      transUnionLatestChangeHistoryLog?.changeDate,
                      intl,
                    ),
                    formatTime: formatTime(
                      transUnionLatestChangeHistoryLog?.changeDate,
                      intl,
                    ),
                  })}
                </Typography>
              </SetupGridItem>
            )}
        </>
      )}
      <SetupGridItem
        label={
          <>
            <FormattedMessage {...messages.transunionCode} />*
          </>
        }
      >
        {editMode ? (
          <TextInput
            name="transunionPropertyId"
            value={transunionPropertyId}
            editMode={editMode}
            onChange={onChange}
            disabled={!isTransUnionActive}
            required={isTransUnionActive}
          />
        ) : (
          <span>{transunionPropertyId || '---'}</span>
        )}
      </SetupGridItem>
    </>
  );
}

export default LegacyScreeningsSetup;
